import React from "react";

export function ErroModal({ erro }) {
  if (!erro) return null;
  return (
    <div
      className="alert alert-danger py-2 px-3 mb-3"
      role="alert"
      style={{ fontSize: "0.9rem", borderRadius: "6px" }}
    >
      {erro}
    </div>
  );
}
